import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightbulb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.75 8.16658C8.86667 7.5832 9.15833 7.17483 9.625 6.70813C10.2083 6.18308 10.5 5.42469 10.5 4.6663C10.5 3.73796 10.1313 2.84765 9.47487 2.19122C8.8185 1.53479 7.92826 1.16602 7 1.16602C6.07174 1.16602 5.1815 1.53479 4.52513 2.19122C3.86875 2.84765 3.5 3.73796 3.5 4.6663C3.5 5.24968 3.61667 5.94973 4.375 6.70813C4.78333 7.11649 5.13333 7.5832 5.25 8.16658M5.25 10.5001H8.75M5.83333 12.8336H8.16667",
		stroke: "#614395",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgLightbulb;
